<template>
    <div>
        <div>
            <h2>Dashboard</h2>
            <hr />
        </div>
        <div v-if="(isUserE106 || isUserShpo) && !isUserShpoCrApproving">
            <e106Compliances type='todo' :isUserRc="isUserShpoRc"></e106Compliances>
        </div>
        <div v-if="!(isUserClg || isUserE106 || isUserShpoCrApproving || isClientUser)">
            <fieldworkRequests type='todo' :isUserRc="isUserShpoRc"></fieldworkRequests>
        </div>

        <div v-if="!(isUserClg || isUserE106 || isUserShpoCrApproving || isClientUser)">
            <fileSearches type='todo' :isUserRc="isUserShpoRc"></fileSearches>
        </div>

        <div v-if="!isUserClg && !isUserE106">
            <investigations type='todo' :isUserRc="isUserShpoRc"></investigations>
        </div>

        <div v-if="(isUserShpo || isUserBlm) && !isUserShpoCrApproving">
            <undertakings type='todo' :isUserRc="isUserShpoRc"></undertakings>
        </div>

        <div v-if="isUserBlm">
            <moasPas type='todo'></moasPas>
        </div>
        <div v-if="canViewRadioCarbon">
            <labResults type='todo'></labResults>
        </div>

        <div v-if="(isUserClg || isUserShpo) && !isUserShpoCrApproving">
            <buildingSurveys type='todo' :isUserRc="isUserShpoRc"></buildingSurveys>
        </div>
        <div v-if="isUserClg || isUserShpo">
            <buildingReconForms type='todo' :isUserRc="isUserShpoRc"></buildingReconForms>
        </div>
        <div v-if="!(isUserClg || isUserE106 || isUserShpoCrApproving || isClientUser)">
            <siteNumberRequests type='todo'></siteNumberRequests>
        </div>
        <div v-if="isUserShpo && !isUserShpoCrApproving">
            <mediaNotification></mediaNotification>
        </div>
    </div>
</template>

<script>

import loggingService from '../services/util/loggingService'
//import investigationService from '../services/investigationService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

import fieldworkRequests from './FieldworkRequests.vue'
import investigations from './Investigations.vue'
import undertakings from './Undertakings.vue'
import fileSearches from './FileSearches.vue'
import moasPas from './MoasPas.vue'
import labResults from '@/components/LabResults'
import e106Compliances from './E106Compliances'
import buildingReconForms from './BuildingReconForms'
import buildingSurveys from './BuildingSurveys'
import siteNumberRequests from './SiteNumberRequests'
import mediaNotification from '@/components/MediaNotification'

export default {
    components: {
        fieldworkRequests,
        investigations,
        undertakings,
        fileSearches,
        moasPas,
        labResults,
        e106Compliances,
        buildingReconForms,
        buildingSurveys,
        siteNumberRequests,
        mediaNotification
    },
    data () {
        return {
            isDebug: false
            // investigationSearchDto: { },
            // investigationResult: { }
        }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        // is user BLM?
        isUserBlm: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser])
        },
        canViewRadioCarbon: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ShpoAdministrator, roleService.RoleEnum.ShpoCrApprovingUser])
        },
        isUserClg: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.CLGConsultant])
        },
        isUserE106: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.E106User])
        },
        isUserShpo: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isUserShpoCr: function () {
            var shpoRoleList = [
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isUserShpoCrApproving: function () {
            return (this.shpoUserDto && this.shpoUserDto.roleList.length === 1 && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ShpoCrApprovingUser]))
        },
        isUserShpoRc: function () {
            var rcRoleList = [
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, rcRoleList))
        },
        isClientUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ClientUser])
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Dashboard', 'mounted')
        // investigationService.todo(this.$http, this.investigationSearchDto).then(response => {
        //     this.investigationResult = response.data
        // })
    }
}

</script>



// WEBPACK FOOTER //
// Dashboard.vue?0789037a